import { IBillableServiceModel } from "@/Administration/Models/UI/BillableService/IBillableServiceModel";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import { useOverlay } from "@/Common/CustomHooks/useOverlay";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IBillableServiceSearchSettingsProps {
    model: IBillableServiceModel;
    id: string;
    className: string;
    refreshServiceCallBack: (s: IBillableServiceModel, reload: boolean, closeSettings: boolean) => void;
    onOkCallBack: (s: IBillableServiceModel) => void;
    onCancelCallBack: () => void;
}

function BillableServiceSearchSettings(props: Readonly<IBillableServiceSearchSettingsProps>): JSX.Element {
    useOverlay("BillableServiceSearchSettings", { transparent: true });

    return (
        <div id={props.id} className={props.className} style={{ maxHeight: "700px" }}>
            <table className="f-content">
                <thead>
                    <tr>

                        <th><CheckboxControl
                            id="sites_check"
                            label={cacheStore.GetString("SitesLabel")}
                            checked={props.model.get("Sites_AllSelected")}
                            target={CheckboxTarget.Myle_Admin_BillableService_Sites_AllCheck}
                            operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                        />
                        </th>

                        <th>
                            <CheckboxControl
                                id="CostCenter_check"
                                label={cacheStore.GetString("CostCenterLabel")}
                                checked={props.model.get("CostCenters_AllSelected")}
                                target={CheckboxTarget.Myle_Admin_BillableService_CostCenters_AllCheck}
                                operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                            />

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {props.model.get("Sites").count() > 1 && (
                            <td>
                                <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                    <CheckboxControl
                                        id="billableService_NullSite"
                                        label="NO SITES"
                                        operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                                        checked={props.model.get("ShowNullSites")}
                                        target={CheckboxTarget.Myle_Admin_BillableService_Sites_NullCheck}
                                        DivWrap={true}
                                    />

                                    <CheckedListControl
                                        DataSource={props.model.get("Sites")}
                                        Operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                                    />
                                </div>
                            </td>
                        )}
                        <td>
                            <div style={{ maxHeight: "400px", overflow: "auto" }}>
                                <CheckboxControl
                                    id="billableService_NullCostCenter"
                                    label="No COST CENTERS"
                                    operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                                    checked={props.model.get("ShowNullCostCenters")}
                                    target={CheckboxTarget.Myle_Admin_BillableService_CostCenters_NullCheck}
                                    DivWrap={true}
                                />

                                <CheckedListControl
                                    DataSource={props.model.get("CostCenters")}
                                    Operation={LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange}
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <SearchSettingsFooter
                onClose={() => props.onCancelCallBack()}
                onOk={() => sessionStore.dispatch(LocalOperations.AdministrationBillableService.BillableService_SearchSettings_OkClick)}
                onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.AdministrationBillableService.SearchSettings_ColumnOrderingPopup_Open)}
                onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.AdministrationBillableService.BillableService_SearchSettings_OnResultsPerPageChange, { value })}
                selectedPageSizeOption={props.model.get("SelectedPageSizeOption")}
                pageSizeOptions={props.model.get("PageSizeOptions").toArray()}
            />
        </div>
    );
}

export { BillableServiceSearchSettings };
